import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import { EntriesProvider } from './context/EntriesContext';
import DeckDistributionChart from './components/DeckDistributionChart';
import DeckDetailPage from './components/DeckDetailPage';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function App() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check API status on mount
    axios.get(`${API_BASE_URL}/health`)
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setError('Could not connect to API. Make sure the backend server is running on port 8000.');
        setLoading(false);
      });
  }, []);

  // Debug: log every click in the app (runs on all pages)
  useEffect(() => {
    const fn = (e) => console.log('APP: click', e.target?.tagName, e.target?.id || e.target?.className || '');
    document.addEventListener('click', fn, true);
    return () => document.removeEventListener('click', fn, true);
  }, []);

  if (loading && !error) {
    return (
      <div className="App">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="App">
        {error && (
          <div className="error-message">
            <p>{error}</p>
            <p>Make sure you've started the backend server: <code>cd backend && uvicorn app.main:app --reload</code></p>
          </div>
        )}

        {!error && (
          <EntriesProvider>
            <div className="tabs">
              <NavLink
                to="/"
                className={({ isActive }) => `tab ${isActive ? 'active' : ''}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                Tournament Data
              </NavLink>
              {/* Add more tabs here as features are added */}
            </div>

            <main className="App-main">
              <Routes>
                <Route
                  path="/"
                  element={
                    <section className="chart-section">
                      <DeckDistributionChart />
                    </section>
                  }
                />
                <Route path="/decks/:deckName" element={<DeckDetailPage />} />
              </Routes>
            </main>
          </EntriesProvider>
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
